import React, { Component } from 'react'
import DocumentRepositoryLoanListUI from './DocumentRepositoryLoanListUI'

class DocumentRepositoryLoanListSF extends Component {
  constructor(props) {
    super(props)
    this.state = { copyToClipboardText: null }
  }

render() {
    return (
      <DocumentRepositoryLoanListUI
        context={this.props.context}
        loanList={this.props.loanList}
        onRowClick={this.onRowClick}
        onRefreshClick={this.props.onRefreshClick}
        onCopyToClipboard={this.onCopyToClipboard}
        copyToClipboardText={this.state.copyToClipboardText}
        onDownloadAllClick={this.props.onDownloadAllClick}
        downloadingAll={this.props.downloadingAll}
      />
    )
  }

  onRowClick = (event) => {
    let loanId = event.currentTarget.getAttribute('data-row-id')
    window.location.href = `/su/documentRepository/loans/${loanId}`
  }

  onCopyToClipboard = (text) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => this.setState({ copyToClipboardText: null }), 3000)
  }
}

export default DocumentRepositoryLoanListSF